module.exports = __webpack_public_path__ + "img/103_doc_front.14f26101.svg";